<script>
export default {
  computed: {
    isDisabled () {
      return Boolean(this.params.disabled)
    },
    title () {
      return this.params.title || this.params.tooltip || ''
    },
    ariaLabel () {
      return this.params.ariaLabel || this.title || 'Action'
    }
  },
  methods: {
    handleClick () {
      if (this.isDisabled || typeof this.params.onClick !== 'function') {
        return
      }
      const rowData = this.params.data
      this.params.onClick(rowData, this.params)
    }
  }
}
</script>

<template>
  <div
    class="text-center"
    :class="[params.cellClass, isDisabled ? 'cursor-not-allowed' : 'cursor-pointer']"
    :title="title"
    :aria-label="ariaLabel"
    :aria-disabled="isDisabled ? 'true' : 'false'"
    role="button"
    @click="handleClick"
  >
    <i :class="params.iconClass"></i>
  </div>
</template>
